import { defineMessages } from 'react-intl';

export default defineMessages({
    IncludedLabel: {
        id: 'cep.components.sgRenewalSummary.IncludedLabel',
        defaultMessage: 'Additional cover(s) included:'
    },
    NotIncludedLabel: {
        id: 'cep.components.sgRenewalSummary.NotIncludedLabel',
        defaultMessage: 'Cover(s) not included:'
    },
});
